import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { MovimentarCompraEtapaRequest } from '../../requests/compras/movimentar-compra-etapa.request';
import { MovimentarComprasEtapaLoteRequest } from '../../requests/compras/movimentar-compras-etapa-lote.request';
import { MovimentarCompraEtapaResponse } from '../../responses/compras/movimentar-compra-etapa.response';
import { MovimentarComprasEtapaLoteResponse } from '../../responses/compras/movimentar-compras-etapa-lote.response';

@Injectable({
  providedIn: 'root',
})
export class CompraEtapaService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'CompraEtapa';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public movimentarEtapa(idCompra: number, request: MovimentarCompraEtapaRequest): Observable<MovimentarCompraEtapaResponse> {
    return this.httpClient
      .put<MovimentarCompraEtapaResponse>(`${this.apiUrl}/${idCompra}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Move vários pedidos para a mesma etapa, tudo ou nada (grupo da NF no quadro). Não aceita `cancelado`. */
  public movimentarEtapaLote(request: MovimentarComprasEtapaLoteRequest): Observable<MovimentarComprasEtapaLoteResponse> {
    return this.httpClient
      .put<MovimentarComprasEtapaLoteResponse>(`${this.apiUrl}/lote`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
